<template>
  <transition name="fade">
    <div v-if="visible" class="fixed" @click="closePopup">
      <div class="modal-card" @click.stop>
        <div class="modal-header">
          <div>
            <div class="modal-title">Detalle del Pago</div>
            <div class="modal-subtitle">{{ props.paymentInfo.created_date }}</div>
          </div>
          <button type="button" class="close-btn" @click="closePopup">&times;</button>
        </div>

        <div class="amount-banner">
          <span style="font-size: 13px; color: var(--text-color-light);">Total Transferido</span>
          <span style="font-size: 1.6rem; font-weight: 700; color: var(--primary-color);">
            {{ formatAmount(props.paymentInfo.amount) }}€
          </span>
        </div>

        <div style="margin-top: 1.25rem;">
          <h4 style="font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: var(--text-color-light); margin-bottom: 0.5rem;">
            Movimientos incluidos
          </h4>
          <div class="table-container" style="margin-top: 0; max-height: 350px;">
            <table>
              <thead>
                <tr>
                  <th style="width: 70%;">Descripción</th>
                  <th style="width: 30%;">Cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(item, index) in movements"
                  :key="index"
                  :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
                >
                  <td style="width: 70%; font-weight: 500; text-align: left; padding-left: 1rem;">{{ item.description }}</td>
                  <td style="width: 30%; font-weight: 700; text-align: right; padding-right: 1rem;">{{ formatAmount(item.amount / 100) }}€</td>
                </tr>
                <tr v-if="!movements || movements.length === 0">
                  <td colspan="2" style="padding: 1.5rem; text-align: center; color: var(--text-color-light);">
                    Sin movimientos registrados.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
  
  <script setup>
  import { ref, watch, defineProps } from 'vue';

  const props = defineProps({
    paymentInfo: Object,
    movements: Object,
  });
  
  const visible = ref(false);

  watch(() => props.paymentInfo, (newVal) => {
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    visible.value = false;
    history.back();
  };

  function formatAmount(valor) {
    return new Intl.NumberFormat('es-ES', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).format(valor);
  }

  </script>
  
  <style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.modal-card {
  background-color: var(--white);
  padding: 1.75rem;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-xl);
  width: 90%;
  max-width: 620px;
  max-height: 88vh;
  overflow-y: auto;
  border: 1px solid var(--border-color);
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from { transform: translateY(12px) scale(0.98); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid var(--border-color-subtle);
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-color-dark);
}

.modal-subtitle {
  font-size: 13px;
  color: var(--text-color-light);
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--text-color-light);
  cursor: pointer;
  padding: 0 4px;
  transition: color var(--transition-fast);
}

.close-btn:hover {
  color: var(--text-color-dark);
}

.amount-banner {
  background: var(--very-clear-gray);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}
</style>
  